import { FC } from 'react'
import { useDateFormatting } from 'logic/hooks/useDateFormatting'

export const CreatedAtCell: FC<{ date: Date }> = ({ date }) => {
  const formatDate = useDateFormatting()

  return <div>{formatDate('historyDateTime', date)}</div>
}
